// extracted by mini-css-extract-plugin
export var scrollArea = "_oy-0";